import { jsx } from "react/jsx-runtime";
import { cloneElement } from "react";
import { toast } from "react-hot-toast";
import { nanoid } from "nanoid";
import { IconCancel, IconCheck } from "@bynder/icons";
import { Button } from "./Button.js";
import { Thumbnail } from "./Thumbnail.js";
import { Spinner } from "./Spinner.js";
import { Baloon } from "./Baloon.js";
const DEFAULT_DURATION = 8e3;
const PERMANENT_DURATION = 288e5;
function notify({
  isPersistent,
  button,
  id = nanoid(),
  variant,
  thumbnail,
  ...props
}) {
  return toast((t) => /* @__PURE__ */ jsx(Baloon, {
    thumbnail: getThumbnail(thumbnail, variant),
    ...props,
    button: button ? cloneElement(button, {
      variant: "clean",
      onClick() {
        var _a, _b;
        (_b = (_a = button.props).onClick) == null ? void 0 : _b.call(_a);
        toast.dismiss(t.id);
      }
    }) : /* @__PURE__ */ jsx(Button, {
      variant: "clean",
      onClick: () => {
        toast.dismiss(t.id);
      },
      icon: /* @__PURE__ */ jsx(IconCancel, {}),
      title: "Close"
    })
  }), {
    id,
    // `react-hot-toast` currently doesn't support persistent notifications, so as workaround we use very long duration
    // https://github.com/timolins/react-hot-toast/issues/36
    duration: isPersistent ? PERMANENT_DURATION : DEFAULT_DURATION
  });
}
notify.dismiss = function dismiss(notificationId) {
  toast.dismiss(notificationId);
};
notify.remove = function remove(notificationId) {
  toast.remove(notificationId);
};
function getThumbnail(thumbnail, variant) {
  const thumbnails = {
    loading: /* @__PURE__ */ jsx(Thumbnail, {
      shape: "circle",
      backgroundColor: "transparent",
      icon: /* @__PURE__ */ jsx(Spinner, {})
    }),
    success: /* @__PURE__ */ jsx(Thumbnail, {
      shape: "circle",
      backgroundColor: "green500",
      icon: /* @__PURE__ */ jsx(IconCheck, {}),
      iconColor: "white"
    }),
    error: /* @__PURE__ */ jsx(Thumbnail, {
      shape: "circle",
      backgroundColor: "red500",
      icon: /* @__PURE__ */ jsx(IconCancel, {}),
      iconColor: "white"
    })
  };
  if (thumbnail) {
    return thumbnail;
  }
  if (variant) {
    return thumbnails[variant];
  }
}
export {
  notify
};
//# sourceMappingURL=notify.js.map
